import { defaultTo } from "lodash";
import { IModel } from ".";
import { ModelRecord } from "./Model";

export interface IPartnerModel extends IModel {
    partnerId: number;
    name: string;
    label: string;
    description: string | undefined;
    sourceSystemKey: string;
}

export class PartnerModel implements ModelRecord<IPartnerModel> {
    partnerId: number;
    name: string;
    label: string;
    description: string | undefined;
    sourceSystemKey: string;
    rowVersion: string;


    constructor(init?: Partial<IPartnerModel>) {
        this.rowVersion = defaultTo(init?.rowVersion, '');
        this.partnerId = defaultTo(init?.partnerId, 0);
        this.name = defaultTo(init?.name, '');
        this.label = defaultTo(init?.label, '');
        this.description = defaultTo(init?.description, undefined);
        this.sourceSystemKey = defaultTo(init?.sourceSystemKey, '');
    }
}
